import React from 'react';
import { StaticReferencePage } from './StaticReferencePage';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { TnvedCode } from '../../types';

export const TnvedCodesPage: React.FC = () => {
  const { t } = useLanguage();
  const { tnvedCodes } = useData();

  return (
    <StaticReferencePage<TnvedCode>
      title={t('references.tnvedCodes')}
      items={tnvedCodes.items}
      columns={TABLE_COLUMNS.TNVED_CODES}
    />
  );
};
